import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

export type ApplicationType = 'Explore' | 'Expertab' | 'Expertir' | (string & {});

/**
 * 'raw' — changelog served exactly as published, to be displayed untouched.
 * 'legacy' — changelog stored in database as a single ';' separated line.
 */
export type ChangelogFormat = 'raw' | 'legacy';

export interface InfoProductVersionDto {
  numero: string;
  changelog: string | null;
  date: string;
  setupUrl: string | null;
  changelogFormat: ChangelogFormat;
}

export interface InfoProductDetailsDto {
  description: string[];
  versions: InfoProductVersionDto[];
}

export interface InfoProductDto {
  id: number;
  application: ApplicationType;
  details: InfoProductDetailsDto;
}

@Injectable({
  providedIn: 'root'
})
export class InfoProductsService {

  constructor(private readonly httpService: HttpService) { }

  getAll(): Observable<InfoProductDto[]> {
    return this.httpService.get<InfoProductDto[]>('InfoProducts');
  }

  getDocumentationUrl(s3Key: string): Observable<{ url: string }> {
    return this.httpService.get<{ url: string }>('InfoProducts/Documentation', { s3Key });
  }
}
